import { Info } from 'lucide-react';
import type { ReactNode } from 'react';

interface InfoNoteProps {
  children: ReactNode;
}

const InfoNote = ({ children }: InfoNoteProps) => (
  <div className="flex items-start gap-2 rounded-[8px] bg-[#007AFF1F] p-2 reg12 text-black">
    <Info size={16} strokeWidth={1.8} className="mt-0.5 shrink-0 text-text-blue-100" />
    <p>{children}</p>
  </div>
);

export default InfoNote;
